import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'showRightHeaderContainer',
    standalone: true
})
export class ShowRightHeaderContainerPipe implements PipeTransform {

    transform(routerurl: string, isRevdriver: boolean): boolean {
        if (!isRevdriver) {
            if (routerurl.includes('/account/signupVerification')) {
                return true;
            }
        }
        return false;
    }

}
